import { useLayoutEffect, useRef } from 'react'

import { GRETA_AI_CHAT_MORE_CHATS_TRIGGER_PX } from '../../GretaAIChatChatList.constants'
import {
  getIsGretaAIChatSelectionChanged,
  revealGretaAIChatChat,
} from '../../GretaAIChatChatList.utils'

export function useGretaAIChatChatListScroll({
  activeChatId,
  chatListScrollTopRef,
  chatListSeenChatIdRef,
  hasMoreChats,
  hasMoreChatsFailed,
  isMoreChatsLoading,
  isRows,
  loadMoreChats,
}) {
  const sectionsRef = useRef(null)
  const hasAdjustedScrollRef = useRef(false)

  useLayoutEffect(() => {
    const node = sectionsRef.current

    if (isRows && node) {
      const isSelectionChanged = getIsGretaAIChatSelectionChanged(
        activeChatId,
        chatListSeenChatIdRef.current
      )

      if (!hasAdjustedScrollRef.current) {
        hasAdjustedScrollRef.current = true

        if (isSelectionChanged) {
          revealGretaAIChatChat(node, activeChatId)
        } else {
          node.scrollTop = chatListScrollTopRef.current
        }
      } else if (isSelectionChanged) {
        revealGretaAIChatChat(node, activeChatId)
      }

      chatListSeenChatIdRef.current = activeChatId
    }
  }, [activeChatId, isRows])

  function handleListScroll(event) {
    const node = event.currentTarget
    const distanceFromEnd =
      node.scrollHeight - node.scrollTop - node.clientHeight

    chatListScrollTopRef.current = node.scrollTop

    if (
      hasMoreChats &&
      !isMoreChatsLoading &&
      !hasMoreChatsFailed &&
      distanceFromEnd <= GRETA_AI_CHAT_MORE_CHATS_TRIGGER_PX
    ) {
      loadMoreChats()
    }
  }

  return { handleListScroll, sectionsRef }
}
